import { useCallback, useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Per-user pinned-nav state, persisted to localStorage.
 * Stores an ordered list of nav `to` paths.
 */
export function usePinnedNav() {
    const { user } = useAuth();
    const key = user?.id ? `hemaia_pinned_${user.id}` : null;
    const [pinned, setPinned] = useState([]);

    useEffect(() => {
        if (!key) { setPinned([]); return; }
        try {
            const raw = localStorage.getItem(key);
            setPinned(raw ? JSON.parse(raw) : []);
        } catch (_) { setPinned([]); }
    }, [key]);

    const persist = useCallback((next) => {
        if (!key) return;
        try { localStorage.setItem(key, JSON.stringify(next)); } catch (_) {}
        setPinned(next);
    }, [key]);

    const isPinned = useCallback((to) => pinned.includes(to), [pinned]);

    const toggle = useCallback((to) => {
        const next = pinned.includes(to)
            ? pinned.filter((p) => p !== to)
            : [...pinned, to];
        persist(next);
    }, [pinned, persist]);

    return { pinned, isPinned, toggle };
}
